<template>
  <section class="content-section">
    <render v-for="(item, i) in detail.content" :key="i" :config="item" v-on="$listeners"></render>
  </section>
</template>

<script>
import Render from './Render';

export default {
  name: 'ContentRender',
  components: {
    Render
  },
  props: {
    // content config
    content: {
      type: [String, Object]
    }
  },
  data(){
    return {
      detail: {
        content: []
      }
    };
  },
  mounted(){
    if (typeof this.content === 'string' && this.content){
      this.detail = JSON.parse(this.content);
    } else if (this.content && this.content.content){
      this.detail.content = [].concat(this.content.content);
    }
  },
  watch: {
    content: {
      handler: function (val){
        if (val){
          if (typeof val === 'string'){
            this.detail = JSON.parse(val);
          } else {
            this.detail = val;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    renderCompName(item){
      if (!item.type){
        return false;
      }
      return `render-${item.type.replace('_', '-')}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/standard';

.content-section {
  text-align: left;
  color: $color_mb1_front;
  @include font_text_m($height_l);
  word-break: break-word;

  ::v-deep .title,
  ::v-deep .paragraph,
  ::v-deep .heading,
  ::v-deep .code-block,
  ::v-deep .list,
  ::v-deep .blockquote,
  ::v-deep .image {
    margin-top: sizeTrans($space_30);
  }

  ::v-deep .list {
    margin-left: sizeTrans($space_20);
  }

  ::v-deep .description {
    margin-top: sizeTrans($space_5);
    text-align: center;
    font-size: sizeTrans(12);
    color: $color_mb4_front;
  }
}
</style>